/* eslint-disable */
import { CropPortrait } from '@material-ui/icons';
import { React, Fragment, Component } from 'react';
import Button from '@material-ui/core/Button';
// import Typography from '@material-ui/Typography';
// import Breadcrumbs from '@material-ui/Breadcrumbs';
// import Link from '@material-ui/Link';

// function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
//   event.preventDefault();
//   console.info('You clicked a breadcrumb.');
// }
import moment from 'moment';

import DataTable from 'react-data-table-component';
import Select from 'react-select'

import Spinner from 'components/Spinner.js';

const columns = [
  {
      name: 'Username',
      selector: row => row.username,
      sortable: true,
  },
  {
    name: 'Last Name',
    selector: row => row.last_name,
    sortable: true,
  },
  {
    name: 'Other Names',
    selector: row => row.other_names,
    sortable: true,
  },
  {
    name: 'Last Login',
    selector: row => moment(row.last_login).format('YYYY/MM/D HH:mm:ss'),
    sortable: true,
  },
];

export default class UserList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTable: false,
      showSpinner: true,
      showSelect: false,
      site: null,
      sites: [],
      data: []
    };
  }

  componentDidMount() {
    // this.state.socket.on('login', user => this.setState({ user, waitingForAuth: false }));
    // this.state.socket.on('error', err => this.setState({ user: null, waitingForAuth: false }));
    var $this = this;
    fetch('/api/shared/users/list/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({})
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          $this.setState({
            data: data.data.users,
            showSpinner: false,
            showTable: true
          });
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  // handleSiteChange = (site) => {
  //   this.setState({
  //     showSpinner: true,
  //     site: site.value
  //   });
  //   var $this = this;
  //   fetch('/api/shared/stockCountJobs/search', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //       // 'Content-Type': 'application/x-www-form-urlencoded',
  //     },
  //     body: JSON.stringify({LOCNCODE: site.value})
  //   })
  //     .then(response => response.json())
  //     .then(data => {
  //       console.log(data);
  //       if (data.status.success) {
  //         $this.setState({
  //           data: data.data.stockCountJobs,
  //           showSpinner: false,
  //           showTable: true
  //         });
  //       }
  //       else {
  //         $this.setState({
  //           showSpinner: false
  //         });
  //         alert('There was an error. Please try again later.')
  //       }
  //     });
  // }

  render ()
  {
    var $this = this;
    return (
      <Fragment>
        {/* <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/">
            MUI
          </Link>
          <Link
            underline="hover"
            color="inherit"
            href="/material-ui/getting-started/installation/"
          >
            Core
          </Link>
          <Typography color="text.primary">Breadcrumbs</Typography>
        </Breadcrumbs> */}
        { this.state.showSpinner ?
          <Spinner/> 
          : "" 
        }
        {/* { this.state.showSelect ?
        <Select name="site" defaultValue={{label:this.state.site, value:this.site}}
          onChange={this.handleSiteChange}
          options ={this.state.sites.map(e => 
            { return {
              value: e.locncode,
              label: e.locncode + ' (' + e.locndscr + ')'
            };}
          ) }
          />
        :null } */}
        { this.state.showTable ?
        <DataTable
              columns={columns}
              data={this.state.data}
              keyField='id'
              onRowClicked={r => this.props.setId(r.id)}
              striped
              highlightOnHover
              pointerOnHover
              dense
              pagination
          />
          : ""
        }
        <Button variant="contained" color="primary" onClick={() => $this.props.setId(null)}>Add New User</Button>
      </Fragment>
    );
  }
}
